import React from 'react';
import Card from './Card';

const CardList = ({Heroes}) => {
    return (
        <div>
            {Heroes.map((user,i)=>{
        return <Card key={i} 
                id={Heroes[i].id} 
                name={Heroes[i].name} 
                email={Heroes[i].email} />

    })}
        </div>
    );
}

export default CardList;